<template>
  <div class="gallery-page">
    <section class="page-hero page-hero--gallery">
      <div class="page-hero__shade"></div>
      <div class="site-shell page-hero__content">
        <p class="eyebrow">JADE COLLECTION</p>
        <h1>馆藏作品</h1>
        <p>观玉之形，读匠人藏在方寸之间的心意。</p>
      </div>
    </section>

    <section class="page-section">
      <div class="site-shell">
        <header class="list-heading">
          <div>
            <p>点击即可查看原图与详情</p>
          </div>
          <h2>以玉载道，以刀传情</h2>
        </header>

        <div v-if="loading" class="loading-container"><el-skeleton :rows="6" animated /></div>

        <div v-else-if="works.length" class="collection-grid">
          <article v-for="item in works" :key="item.id" class="collection-card" tabindex="0" @click="showDetail(item)" @keyup.enter="showDetail(item)">
            <div class="collection-card__image">
              <img v-if="item.artworkImage" :src="getImageUrl(item.artworkImage)" :alt="item.name" @error="handleImageError">
              <div v-else class="image-placeholder"><i class="el-icon-picture-outline"></i></div>
              <span class="collection-card__view"><i class="el-icon-zoom-in"></i></span>
            </div>
            <div class="collection-card__body">
              <h3>{{ item.name }}</h3>
              <p>{{ item.material || '玉雕作品' }}</p>
            </div>
          </article>
        </div>

        <el-empty v-else description="暂无作品数据"></el-empty>

        <div class="pagination-wrapper" v-if="pagination.total > pagination.pageSize">
          <el-pagination @current-change="handlePageChange" :current-page="pagination.currentPage" :page-size="pagination.pageSize" layout="prev, pager, next, jumper" :total="pagination.total" :disabled="loading"></el-pagination>
        </div>
      </div>
    </section>

    <el-dialog :visible.sync="dialogVisible" :fullscreen="isMobile" width="88%" top="4vh" custom-class="jade-work-dialog" :show-close="false" :close-on-click-modal="false" @closed="handleDialogClosed">
      <div v-if="currentWork">
        <div v-if="detailLoading" class="dialog-loading"><el-skeleton :rows="6" animated /></div>
        <div v-else class="work-detail">
          <div class="work-detail__header">
            <div>
              <p class="eyebrow">WORK DETAIL</p>
              <h2>{{ currentWork.name }}</h2>
            </div>
            <button type="button" class="icon-button" title="关闭" @click="dialogVisible = false"><i class="el-icon-close"></i></button>
          </div>

          <div class="work-detail__grid">
            <div class="work-detail__media">
              <el-image :src="getImageUrl(currentWork.artworkImage)" :alt="currentWork.name" fit="contain" :preview-src-list="[getImageUrl(currentWork.artworkImage)]">
                <div slot="error" class="image-placeholder"><i class="el-icon-picture-outline"></i><span>图片加载失败</span></div>
              </el-image>
            </div>
            <div class="work-detail__copy">
              <div class="work-detail__section">
                <div><h3>作品描述</h3><p>{{ currentWork.description || '暂无描述' }}</p></div>
              </div>
              <div v-if="currentWork.material" class="work-detail__section">
                <div><h3>材质</h3><p>{{ currentWork.material }}</p></div>
              </div>
              <div v-if="currentWork.size" class="work-detail__section">
                <div><h3>尺寸</h3><p>{{ currentWork.size }}</p></div>
              </div>
              <button v-if="!isMobile" type="button" class="text-link" @click="handleZoomImage(getImageUrl(currentWork.artworkImage))">打开原图 <i class="el-icon-full-screen"></i></button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCollectionList, getCollectionDetail } from '@/api/collection'

export default {
  name: 'GalleryPage',
  data() {
    return {
      loading: false,
      detailLoading: false,
      dialogVisible: false,
      currentWork: null,
      works: [],
      pagination: { currentPage: 1, pageSize: 8, total: 0 },
      isMobile: false
    }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.fetchWorks()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768
    },
    async fetchWorks() {
      this.loading = true
      try {
        const response = await getCollectionList({ pageNum: this.pagination.currentPage, pageSize: this.pagination.pageSize })
        if (response.code === 200) {
          this.works = response.rows || []
          this.pagination.total = response.total || 0
        } else {
          this.$message.error(response.msg || '获取作品列表失败')
        }
      } catch (error) {
        console.error('获取作品列表出错:', error)
        this.$message.error('获取作品列表失败')
      } finally {
        this.loading = false
      }
    },
    async showDetail(item) {
      this.dialogVisible = true
      this.currentWork = item
      this.detailLoading = true
      try {
        const response = await getCollectionDetail(item.id)
        if (response.code === 200) this.currentWork = { ...item, ...(response.data || {}) }
      } catch (error) {
        console.error('获取作品详情出错:', error)
      } finally {
        this.detailLoading = false
      }
    },
    handlePageChange(page) {
      this.pagination.currentPage = page
      this.fetchWorks()
      window.scrollTo({ top: 220, behavior: 'smooth' })
    },
    getImageUrl(path) {
      if (!path) return ''
      return path.startsWith('http') || path.startsWith('data:') ? path : process.env.VUE_APP_BASE_API + path
    },
    handleImageError(event) {
      if (event && event.target) event.target.style.display = 'none'
    },
    handleZoomImage(url) {
      window.open(url, '_blank')
    },
    handleDialogClosed() {
      this.currentWork = null
    }
  }
}
</script>
